import React from 'react';
import Container from './Container';
import HeatMap from './HeatMap';

const caseStudies = [
  {
    title: 'Denver Roofing Pro',
    results: {
      rankingIncrease: '156%',
      leadIncrease: '243%',
      revenueGrowth: '189%'
    },
    heatmapUrl: 'https://images.unsplash.com/photo-1590859808308-3d2d9c515b1a?auto=format&fit=crop&w=800&h=400',
    description: 'Achieved top rankings for 50+ high-value keywords in just 3 months'
  },
  {
    title: 'Texas Roof Masters',
    results: {
      rankingIncrease: '198%',
      leadIncrease: '312%',
      revenueGrowth: '267%'
    },
    heatmapUrl: 'https://images.unsplash.com/photo-1590859808308-3d2d9c515b1a?auto=format&fit=crop&w=800&h=400',
    description: 'Dominated local pack results across 5 major Texas cities'
  }
];

const CaseStudies = () => {
  return (
    <section id="case-studies" className="py-20 bg-gray-50">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Success Stories
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            See how roofing companies are transforming their business with OTTO
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {caseStudies.map((study, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg"
            >
              <div className="relative">
                <HeatMap imageUrl={study.heatmapUrl} />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-0 left-0 p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {study.title}
                  </h3>
                  <p className="text-white/90">{study.description}</p>
                </div>
              </div>

              <div className="p-6">
                <div className="grid grid-cols-3 gap-4">
                  <div className="text-center">
                    <p className="text-3xl font-bold text-blue-600">
                      {study.results.rankingIncrease}
                    </p>
                    <p className="text-sm text-gray-600">Ranking Increase</p>
                  </div>
                  <div className="text-center">
                    <p className="text-3xl font-bold text-blue-600">
                      {study.results.leadIncrease}
                    </p>
                    <p className="text-sm text-gray-600">More Leads</p>
                  </div>
                  <div className="text-center">
                    <p className="text-3xl font-bold text-blue-600">
                      {study.results.revenueGrowth}
                    </p>
                    <p className="text-sm text-gray-600">Revenue Growth</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default CaseStudies;